import { FC, memo } from 'react';
import { useParams } from 'react-router';

import { AppAutocomplete, DomainPunycode } from '@/common/components';
import { AppAutocompleteComponentProps } from '@/common/interfaces';
import { parseSelectData } from '@/common/utils';

import { useAutocompleteDomainsBySiteIdQuery } from '@/modules/Domains';


interface Props extends AppAutocompleteComponentProps {
  siteId: string;
}

export const DomainsAllAutocompleteBySite: FC<Props> = memo(({ siteId, ...props }) => {
  const { domainId } = useParams();

  return (
    <AppAutocomplete<typeof useAutocompleteDomainsBySiteIdQuery>
      { ...props }
      queryArgs={ [siteId] }
      notFoundDescription="Немає доменів для цього сайту"
      placeholder="Знайдіть домен сайту"
      options={ (data) =>
        parseSelectData(
          data?.filter(({ id }) => id !== domainId)?.map((el) => ({ ...el, name: DomainPunycode.stringFormat(el.name) })),
          {
            value: 'id',
            label: 'name'
          }
        )
      }
      query={ useAutocompleteDomainsBySiteIdQuery }
    />
  );
});
